import { ThemeProvider } from '@emotion/react';
import { Box, Grid } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import { NormalButton } from 'components/atoms/Button';
import ImageButton from 'components/atoms/Button/ImageButton';
import Loader from 'components/atoms/loader';
import NormalSearchInput from 'components/molecules/InputText/NormalSearchInput/index';
import InboxLists from 'components/molecules/List/InboxLists';
import { selectAuth } from 'features/auth/authSlice';
import { selectChat, setLoading } from 'features/auth/chatSlice';
import { UserData } from 'interfaces/UserData.interface';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchInboxUsers } from 'utils/Firebase.util';
import { colortheme, ParaText, TabsWrapper, useStyles } from './Body.styles';

const BoxBody = () => {
  const classes = useStyles();
  const chatState = useAppSelector(selectChat);
  const authState = useAppSelector(selectAuth);
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState<string>('General');

  const authStateFollowing: number[] =
    authState?.following?.map(following => following.following.id) || [];
  const [searchPeople, setSearchPeople] = useState<
    { user: UserData; lastMessageTime: number }[]
  >([]);
  const [requests, setRequests] = useState<number>(0);
  const [query, setQuery] = useState<string>('');
  const subscribers: number[] =
    authState.followers?.map(follwer => follwer.follower.id) || [];

  const handleFilter = (query: string) => {
    query = query.toLowerCase();
    if (chatState) {
      const users: { user: UserData; lastMessageTime: number }[] =
        chatState.inboxUsers.filter(user => {
          const username = user.user.username.toLowerCase();
          return username.includes(query);
        });
      setSearchPeople(users);
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      await fetchInboxUsers(authState, dispatch, setLoading);
    };
    fetchUsers();
    //eslint-disable-next-line
  }, [authState.id]);

  return (
    <>
      <ThemeProvider theme={colortheme}>
        <Box className={classes.body}>
          <Box className={classes.controlSection}>
            <NormalSearchInput
              placeholder="Search..."
              onChange={e => {
                handleFilter(e.target.value);
                setQuery(e.target.value);
              }}
            />
            <ImageButton type={'control'} />
          </Box>
          <Grid item xs={12} style={{ marginBottom: '20px' }}>
            <TabsWrapper>
              <Box
                style={{
                  display: 'flex',
                  gap: '5px',
                  flexWrap: 'wrap',
                  justifyContent: 'space-around',
                  padding: '5px',
                }}
              >
                <NormalButton
                  color={`${
                    currentTab === 'General' ? 'yellow' : 'transparent'
                  }`}
                  style={{
                    width: '20%',
                    padding: '.5rem 1rem',
                    borderRadius: '15px',
                    whiteSpace: 'nowrap',
                    fontSize: '12px',
                    minWidth: '80px',
                  }}
                  onClick={() => setCurrentTab('General')}
                >
                  General
                </NormalButton>
                <NormalButton
                  isDisabled={!authState.canPost}
                  color={`${
                    currentTab === 'Backstage' ? 'yellow' : 'transparent'
                  }`}
                  style={{
                    width: '20%',
                    padding: '.5rem 1rem',
                    borderRadius: '15px',
                    whiteSpace: 'nowrap',
                    fontSize: '12px',
                    minWidth: '80px',
                  }}
                  onClick={() => setCurrentTab('Backstage')}
                >
                  Backstage
                </NormalButton>
                <NormalButton
                  color={`${
                    currentTab === 'Requests' ? 'yellow' : 'transparent'
                  }`}
                  style={{
                    width: '20%',
                    padding: '.5rem 1rem',
                    borderRadius: '15px',
                    whiteSpace: 'nowrap',
                    fontSize: '12px',
                    minWidth: '80px',
                  }}
                  onClick={() => setCurrentTab('Requests')}
                >
                  {`Requests (${requests})`}
                </NormalButton>
              </Box>
            </TabsWrapper>
          </Grid>
          <Box className={classes.inboxSection}>
            {chatState.loading ? (
              <Loader />
            ) : chatState.inboxUsers.length === 0 ? (
              <Grid item xs={12} style={{ margin: '1rem .5rem' }}>
                <ParaText>No Result Found</ParaText>
              </Grid>
            ) : currentTab === 'General' ? (
              /*eslint-disable*/
              chatState.inboxUsers
                .filter(inboxUser => {
                  if (
                    !subscribers.includes(inboxUser.user.id) &&
                    (authStateFollowing.includes(inboxUser.user.id) ||
                      authState.generalChats.includes(inboxUser.user.id))
                  ) {
                    if (searchPeople.length > 0 || query.length) {
                      return searchPeople.some(
                        user => user.user.id === inboxUser.user.id
                      );
                    } else {
                      return true;
                    }
                  }
                })
                .map((user, i) => {
                  return (
                    <InboxLists
                      key={i}
                      data={user.user}
                      verified={user.user.verified}
                    />
                  );
                })
            ) : currentTab === 'Backstage' ? (
              chatState.inboxUsers
                .filter(inboxUser => {
                  if (subscribers.includes(inboxUser.user.id)) {
                    if (searchPeople.length > 0 || query.length) {
                      return searchPeople.some(
                        user => user.user.id === inboxUser.user.id
                      );
                    } else {
                      return true;
                    }
                  }
                })
                .map((user, i) => {
                  return (
                    <InboxLists
                      key={i}
                      data={user.user}
                      verified={user.user.verified}
                    />
                  );
                })
            ) : (
              chatState.inboxUsers
                .filter(inboxUser =>
                  !subscribers.includes(inboxUser.user.id) &&
                  !authStateFollowing.includes(inboxUser.user.id) &&
                  !authState.generalChats.includes(inboxUser.user.id)
                    ? (searchPeople.length > 0 || query.length) &&
                      searchPeople.some(
                        user => user.user.id === inboxUser.user.id
                      )
                      ? true
                      : false
                    : false
                )

                .map((user, i) => {
                  setRequests(prev => prev + i + 1);
                  return (
                    <InboxLists
                      key={i}
                      data={user.user}
                      verified={user.user.verified}
                    />
                  );
                })
            )}
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
};

export default BoxBody;
